import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { VbLxpAuthService } from './vb-lxp-auth.service';
import { WebSocketService } from '../shared/websocket.service';

export const mvAuthGuard: CanActivateFn = (route, state) => {
	const router = inject(Router);
	const authService = inject(VbLxpAuthService);
	const webSocketService = inject(WebSocketService);
	const redirectTo = (route.data?.['authRedirectTo'] as string) || '/login';
	const requireAdminRole = route.data?.['requireAdminRole'] === true;

	if (!authService.isAuthenticated()) {
		// Ensure stale/expired token state is fully reset before redirect.
		webSocketService.disconnect();
		authService.clearToken();
		return router.createUrlTree([redirectTo], {
			queryParams: { returnUrl: state.url },
		});
	}

	// Check if admin role is required
	if (requireAdminRole && !authService.isAdmin()) {
		// User is authenticated but doesn't have admin role
		// Disconnect WebSocket, clear token, and redirect to login so they can login with admin credentials
		console.warn('Access denied');
		webSocketService.disconnect();
		authService.clearToken();
		return router.createUrlTree(['/login'], {
			queryParams: { returnUrl: state.url },
		});
	}

	return true;
};
